<template>
  <div class="loading-background">
  <div class="loading-spin">
    <svg  width="80px" height="80px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid" class="lds-ripple" style="animation-play-state: running; animation-delay: 0s; background: none;">
      <circle cx="50" cy="50" r="39.2648" fill="none" ng-attr-stroke="20" ng-attr-stroke-width="20" stroke="#333333" stroke-width="4" style="animation-play-state: running; animation-delay: 0s;">
        <animate attributeName="r" calcMode="spline" values="0;40" keyTimes="0;1" dur="1" keySplines="0 0.2 0.8 1" begin="-0.5s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate>
        <animate attributeName="opacity" calcMode="spline" values="1;0" keyTimes="0;1" dur="1" keySplines="0.2 0 0.8 1" begin="-0.5s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate>
      </circle>
      <circle cx="50" cy="50" r="23.4381" fill="none" ng-attr-stroke="20" ng-attr-stroke-width="20" stroke="#707070" stroke-width="4" style="animation-play-state: running; animation-delay: 0s;">
        <animate attributeName="r" calcMode="spline" values="0;40" keyTimes="0;1" dur="1" keySplines="0 0.2 0.8 1" begin="0s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate>
        <animate attributeName="opacity" calcMode="spline" values="1;0" keyTimes="0;1" dur="1" keySplines="0.2 0 0.8 1" begin="0s" repeatCount="indefinite" style="animation-play-state: running; animation-delay: 0s;"></animate>
      </circle>
    </svg>
    <span class="loading-title">Carregando...</span>
  </div>
  </div>
</template>
<script>
export default {

}
</script>
<style>
  .loading-background {
    z-index: 2000;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    top: 0;
    right: 0;
    /*bottom: 0;*/
    left: 0;
    -webkit-transition: opacity .3s;
    transition: opacity .3s;
    width: 100%;
    max-width: inherit;
    min-height: 600px;
    position: relative;
  }
  .loading-spin {
    top: 50%;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute;
  }
  .loading-title {
    margin-left: auto;
    margin-right: auto;
    display: block;
    text-align: center;
    font-size: 15px;
    font-family: Arial, Helvetica, sans-serif;
    letter-spacing: 0;
    color: #333333;
    opacity: 1;
  }
</style>
